import React, { useContext, useEffect, useState } from 'react'
import 'firebase/firestore'

import { FirebaseContext } from '../idealline/Firebase'

const timestampValue = value => {
  if (!value) return 0
  if (typeof value.toMillis === 'function') return value.toMillis()
  if (Number.isFinite(Number(value))) return Number(value)
  return 0
}

const formatDate = value => {
  const millis = timestampValue(value)
  return millis ? new Date(millis).toLocaleString() : 'Recently imported'
}

const TelemetryImports = () => {
  const auth = useContext(FirebaseContext)
  const [imports, setImports] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!auth.user || auth.user.isAnonymous) return undefined
    const unsubscribe = auth.app.firestore()
      .collection('telemetry')
      .where('userId', '==', auth.user.uid)
      .limit(100)
      .onSnapshot(snapshot => {
        const records = snapshot.docs
          .map(document => ({ id: document.id, ...document.data() }))
          .sort((a, b) => timestampValue(b.updatedAt || b.createdAt) - timestampValue(a.updatedAt || a.createdAt))
        setImports(records)
        setLoading(false)
        setError(null)
      }, snapshotError => {
        console.error('Could not load telemetry imports:', snapshotError)
        setLoading(false)
        setError('Your imported sessions could not be loaded.')
      })
    return unsubscribe
  }, [auth.app, auth.user])

  return (
    <section className="mt-10" aria-labelledby="telemetry-imports-heading">
      <h2 id="telemetry-imports-heading">Telemetry imports</h2>
      {loading && <p>Loading your imported sessions…</p>}
      {error && <p role="alert">{error}</p>}
      {!loading && !error && imports.length === 0 && <p>Your Alfano and iRacing imports will appear here.</p>}
      {imports.length > 0 && <div className="grid md:grid-cols-2 gap-4 mt-4">
        {imports.map(record => {
          const report = record.derivedReport || {}
          const trackName = report.track?.name || record.sourceFile?.trackName || 'Telemetry session'
          const fileName = record.sourceFile?.name || `${String(record.source || 'telemetry').toUpperCase()} import`
          return (
            <article className="border border-gray-200 rounded-xl p-5 bg-white" key={record.id}>
              <p className="text-xs uppercase tracking-wide text-gray-500">{String(record.source || 'telemetry').toUpperCase()} · {record.status || 'processing'}</p>
              <h3 className="text-xl mt-1">{trackName}</h3>
              <p className="text-sm text-gray-600 break-all">{fileName}</p>
              <p className="text-xs text-gray-500 mt-2">{formatDate(record.updatedAt || record.createdAt)}</p>
              <a className="inline-block mt-4 font-semibold text-indigo-700" href={`/telemetry-report/?id=${encodeURIComponent(record.id)}`}>Open report</a>
            </article>
          )
        })}
      </div>}
    </section>
  )
}

export default TelemetryImports
